import { useQuery } from "@tanstack/react-query";
import { Select } from "antd";
import { api } from "../api/client";

interface PermissionItem {
  code: string;
  label?: string;
  name?: string;
  group?: string;
}

interface Props {
  value?: string[];
  onChange?: (value: string[]) => void;
  disabled?: boolean;
}

/** Role permissions: a searchable multi-select with Russian names; wildcards like `nsi.*` or `*` can be typed. */
export function PermissionsSelect({ value, onChange, disabled }: Props) {
  const permissions = useQuery({ queryKey: ["meta", "permissions"], queryFn: () => api.get<PermissionItem[]>("/meta/permissions"), staleTime: 300_000 });
  const groups = new Map<string, PermissionItem[]>();
  for (const p of permissions.data ?? []) {
    const key = p.group ?? p.code.split(".")[0];
    groups.set(key, [...(groups.get(key) ?? []), p]);
  }
  const options = [
    { label: "Всё", options: [{ value: "*", label: "* — все права" }] },
    ...[...groups.entries()].map(([group, items]) => ({
      label: group,
      options: [{ value: `${group}.*`, label: `${group}.* — весь раздел` }, ...items.map((p) => ({ value: p.code, label: `${p.label ?? p.name ?? p.code} (${p.code})` }))],
    })),
  ];
  return (
    <Select
      mode="tags"
      allowClear
      showSearch
      optionFilterProp="label"
      value={value ?? []}
      onChange={(v) => onChange?.(v as string[])}
      disabled={disabled}
      loading={permissions.isLoading}
      options={options}
      placeholder="Выберите права или введите маску, например nsi.*"
      maxTagCount="responsive"
    />
  );
}
